/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import './styles.scss'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import Tab from 'components/tab'
import { Accordion, Image, List } from 'semantic-ui-react'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

// TODO Set the correct article ID here
const ARTICLE_ID = '00000000'
const isMobile = window.innerWidth < 769

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: [-1]
    }
  }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    // const newIndex = activeIndex === index ? -1 : index
    // this.setState({ activeIndex: newIndex })
    const openIndex = activeIndex.indexOf(index)
    console.log('openIndex: ', openIndex)
    if (openIndex === -1) {
      const newArray = this.state.activeIndex.slice()
      newArray.push(index)
      this.setState({ activeIndex: newArray })
    } else {
      const newArray = this.state.activeIndex
      newArray.splice(openIndex, 1)
      this.setState({ activeIndex: newArray })
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toggle tab: ' + titleProps.index
    })
  }

  componentDidMount() {
    const domain = parseHostname().publicationDomain
  }

  render() {
    return (
      <div className='index'>
        <ThemeSwitch />
        <Accordion fluid styled>
          <Tab
            activeIndex={this.state.activeIndex}
            index={0}
            handleClick={this.handleClick}
            title='Comment vous protéger?'
            articleId={ARTICLE_ID}
          >
            <List>
              <List.Item>
                <div className='centered'>
                  <Image
                    avatar
                    size='small'
                    src={require('./images/haende.svg')}
                  />
                </div>
                <List.Content>
                  <List.Description>
                    <p>

                      La plupart des maladies infectieuses se transmettent par
                      les mains. <span className='highlighted'>Lavez-vous soigneusement les mains</span> à l’eau et au
                      savon plusieurs fois par jour ou utilisez un désinfectant
                      pour les mains.
                    </p>
                    <p className='readmore'>
                      <span className='hint'>À lire également</span>
                      <a href={'https://' + parseHostname().publicationName + '.ch/25480679'} target='_blank'>
                        <i className='file alternate outline icon' />{' '}
                        <span className='headline'>
                          La seule chose qui protège contre les virus – et que tout le monde fait faux
                        </span>
                      </a>
                    </p>
                  </List.Description>
                </List.Content>
              </List.Item>
              <List.Item>
                <div className='centered'>
                  <Image
                    avatar
                    size='small'
                    src={require('./images/husten.svg')}
                  />
                </div>
                <List.Content>
                  <List.Description>
                    <p>
                    Lorsque vous toussez et éternuez, <span className='highlighted'>tenez un mouchoir sur la bouche et le nez</span>. Si vous n’avez pas de mouchoir, mettez le coude devant le visage, pas les mains. Utilisez toujours un mouchoir en papier. Jetez ensuite le mouchoir et lavez-vous les mains.
                    </p>
                  </List.Description>
                </List.Content>
              </List.Item>
              <List.Item>
                <div className='centered'>
                  <Image
                    avatar
                    size='small'
                    src={require('./images/abstand.svg')}
                  />
                </div>
                <List.Content>
                  <List.Description>
                    <p>
                    Évitez les contacts directs avec d’autres personnes, comme les bises et les poignées de main. Si possible, gardez une distance <span className='highlighted'>d’au moins 1 mètre</span>. Évitez les activités de groupe.
                    </p>
                  </List.Description>
                </List.Content>
              </List.Item>
              <List.Item>
                <div className='centered'>
                  <Image
                    avatar
                    size='small'
                    src={require('./images/reinigen.svg')}
                  />
                </div>
                <List.Content>
                  <List.Description>
                    <p>
                    Le <span className='highlighted'>nettoyage des objets et des surfaces</span> est un moyen efficace de se protéger contre les infections. Les surfaces de contact (poignées de porte, meubles, cuvette de toilettes, etc.) sont nettoyées régulièrement à l’eau chaude, au savon ou avec les produits ménagers habituels.
                    </p>
                  </List.Description>
                </List.Content>
              </List.Item>
              <List.Item>
                <div className='centered'>
                  <Image
                    avatar
                    size='small'
                    src={require('./images/hygienemaske.svg')}
                  />
                </div>
                <List.Content>
                  <List.Description>
                    <p>
                    Ce sont avant tout <span className='highlighted'>les personnes malades qui doivent porter un masque de protection</span> afin de réduire la transmission des agents pathogènes à leur entourage. Les masques d’hygiène n’ont de sens qu’en combinaison avec les autres mesures d’hygiène et règles de comportement.
                    </p>
                  </List.Description>
                </List.Content>
              </List.Item>
            </List>
            <hr />
            <p>
              <strong>Infoline de la Confédération</strong>
              <br />
              +41 58 463 00 00
              <br />
              Tous les jours 24/24
              <br />
              <a
                href='https://www.bag.admin.ch/bag/fr/home/krankheiten/ausbrueche-epidemien-pandemien/aktuelle-ausbrueche-epidemien/novel-cov.html'
                target='_blank'
              >
                Le site de l'OFSP donne régulièrement des informations
              </a>
              .
            </p>
            <p className='source'>
              Source:{' '}
              <a
                href='https://www.bag.admin.ch/bag/fr/home/krankheiten/ausbrueche-epidemien-pandemien/hygiene-pandemiefall/verhaltensregeln-oeffentlichkeit.html'
                target='_blank'
              >
                Office fédéral de la santé publique
              </a>
              <br />
              Conception: lm, Tamedia Interaktiv-Team
            </p>
          </Tab>
        </Accordion>
      </div>
    )
  }
}
